import { signIn } from "next-auth/react";
import { useEffect } from "react";

/**
 * This is a bit of a weird component that allows us to do client-side redirects
 * to pages that we want, whilst keeping the next redirection paradigm used in
 * `getServerSideProps`.
 *
 * Access it by redirecting from within `getServerSideProps` and attaching a
 * redirect query parameter of the desired page. This is usually always the
 * resolvedUrl of the page provided in the `context` parameter given to
 * `getServerSideProps`.
 *
 * e.g.
 * ```ts
 *export const getServerSideProps: GetServerSideProps<Props> = async (context) => {
 *  const session = await getSession(context);
 *  const user = session?.user;
 *  return { redirect: { destination: `/auth/redirect?to=${context.resolvedUrl}`, permanent: false } };
 *
 *  // rest of function...
 *}
 * ```
 */
export default function Redirect() {
  useEffect(() => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    signIn("keycloak", { callbackUrl: params.to || "/" });
  }, []);

  return <></>;
}
